export const getTotalsBook = (game, sport, period, type) => {
    if (!game || typeof game !== 'object' || !['mlb', 'nba', 'nfl'].includes(sport) || !period) return null;

    // Get the node for the period
    const node = period === 'full' ? game : game?.[period];
    if (!node || typeof node !== 'object') return null;
    
    // Pull totals
    const totals = node?.totals;

    if (!totals || !Array.isArray(totals) || totals.length === 0) {
        return null;
    }
    
    if (type === 'first'){
        const firstBook = totals.find(book => book?.lines && book?.lines?.length > 0);
        if (!firstBook) return null;
        
        const recentLine = firstBook.lines[0];
        
        return {
            book: firstBook.book,
            line: sport === 'mlb' ? recentLine.runs : recentLine.pts,
            over: recentLine.over,
            under: recentLine.under
        };
    }else{
        return totals.filter(book => book?.lines && book?.lines?.length > 0).map(book => {
            return {
                book: book.book,
                line: sport === 'mlb' ? book.lines[0].runs : book.lines[0].pts,
                over: book.lines[0].over,
                under: book.lines[0].under
            };
        });
    }
};

export const getMoneylineBook = (game, sport, period, type) => {
    if (!game || typeof game !== 'object' || !['mlb', 'nba', 'nfl'].includes(sport) || !period) return null;

    // Get the node for the period
    const node = period === 'full' ? game : game?.[period];
    if (!node || typeof node !== 'object') return null;
  
    // Pull moneyline
    const moneyline = node?.ml;

    if (!moneyline || !Array.isArray(moneyline) || moneyline.length === 0) {
        return null;
    }
    
    if (type === 'first'){
        const firstBook = moneyline.find(book => book?.lines && book?.lines?.length > 0);
        if (!firstBook) return null;
        
        const recentLine = firstBook.lines[0];
        
        return {
            book: firstBook.book,
            home: recentLine.home,
            away: recentLine.away
        };
    }else{
        // Loop through books and return all books
        return moneyline.filter(book => book?.lines && book?.lines?.length > 0).map(book => {
            return {
                book: book.book,
                home: book.lines[0].home,
                away: book.lines[0].away
            };
        });
    }
};

export const getSpreadBook = (game, sport, period, type) => {
    if (!game || typeof game !== 'object' || !['mlb', 'nba', 'nfl'].includes(sport) || !period) return null;

    // Get the node for the period
    const node = period === 'full' ? game : game?.[period];
    if (!node || typeof node !== 'object') return null;
  
    // Get the spread / runline key
    const spreadKey = sport === 'mlb' ? 'runline' : 'spread';

    // Pull spread/runline
    const spread = node?.[spreadKey];
    if (!spread || !Array.isArray(spread) || spread.length === 0) {
        return null;
    }
    
    if (type === 'first'){
        const firstBook = spread.find(book => book?.lines && book?.lines?.length > 0);
        if (!firstBook) return null;
        
        const recentLine = firstBook.lines[0];
        
        return {
            book: firstBook.book,
            home: {
                points: sport === 'mlb' ? recentLine.home.runs : recentLine.home.pts,
                odds: recentLine.home.odds
            },
            away: {
                points: sport === 'mlb' ? recentLine.away.runs : recentLine.away.pts,
                odds: recentLine.away.odds
            }
        };
    }else{
        return spread.filter(book => book?.lines && book?.lines?.length > 0).map(book => {
            return {
                book: book.book,
                home: {
                    points: sport === 'mlb' ? book.lines[0].home.runs : book.lines[0].home.pts,
                    odds: book.lines[0].home.odds
                },
                away: {
                    points: sport === 'mlb' ? book.lines[0].away.runs : book.lines[0].away.pts,
                    odds: book.lines[0].away.odds
                }
            };
        });
    }
};

// Format odds to add + sign for positive values
export const formatOddsAndLines = (data) => {
    if (!data || isNaN(data)) return 'N/A';
    return data > 0 ? `+${data}` : `${data}`;
};

export const getSportsPeriodOptions = (sport) => {
    if (sport === 'mlb') {
        return [
            { value: 'full', label: 'Full Game' },
            { value: '1st-5-in', label: '1st 5 Innings' },
        ];
    } else if (sport === 'nfl') {
        return [
            { value: 'full', label: 'Full Game' },
            { value: '1st-half', label: '1st Half' },
            { value: '2nd-half', label: '2nd Half' },
            { value: '1st-qtr', label: '1st Quarter' }
        ];
    } else if (sport === 'nba') {
        return [
            { value: 'full', label: 'Full Game' },
            { value: '1st-half', label: '1st Half' },
            { value: '2nd-half', label: '2nd Half' },
            { value: '1st-qtr', label: '1st Quarter' },
            { value: '2nd-qtr', label: '2nd Quarter' },
            { value: '3rd-qtr', label: '3rd Quarter' },
            { value: '4th-qtr', label: '4th Quarter' }
        ];
    } else {
        return [];
    }
};